<template >
  <span @click="callme($event)">
    <date-range-picker
      v-model="dateRange"
      @update="checkConsole($event)"
      :locale-data="locale"
      :opens="opens"
      :singleDatePicker="singleDatePicker"
    >
      <!--Optional scope for the input displaying the dates -->
      <div slot="input" slot-scope="picker" style="cursor:pointer">
        <b-button
          style="margin-top:-3px"
          v-if="!dateRange.startDate && !dateRange.endDate"
          type="button"
          variant="light"
          size="sm"
        >
          <i class="fa fa-calendar fa-lg"></i>
        </b-button>

        <span v-html="selected_date" v-if="dateRange.startDate && dateRange.endDate"></span>
        <i
          class="fa fa-sort-desc ml-2"
          v-if="dateRange.startDate && dateRange.endDate"
          style="position:relative;bottom:3px;"
        ></i>
      </div>
    </date-range-picker>
  </span>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";
import moment from "moment";
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  components: { DateRangePicker },
  props: ["fromDate", "toDate", "singleDatePicker"],
  data() {
    return {
      selected_date: "",
      dateRange: {
        // used for v-model prop
        startDate: this.formatDate(moment().startOf("month")),
        endDate: this.formatDate(moment().endOf("month"))
      },
      opens:
        this.$route.meta.action == "index" &&
        this.$route.meta.page != "customer"
          ? "left"
          : "right", //which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true //show week numbers on each row of the calendar
      },
      ranges: {
        //default value for ranges object (if you set this to false ranges will no be rendered)
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "This month": [moment().startOf("month"), moment().endOf("month")],
        "This year": this.fiscalYear(),
        "Last week": [
          moment()
            .subtract(1, "week")
            .startOf("week"),
          moment()
            .subtract(1, "week")
            .endOf("week")
        ],
        "Last month": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ]
      }
    };
  },
  methods: {
    callme(event) {
      if (typeof event.target.attributes[0] != "undefined") {
        if (event.target.attributes[0]["value"] == "This year") {
          // var date = localStorage.getItem("fiscal_year").split(",");

          this.dateRange = {
            // used for v-model prop
            startDate: this.formatDate(moment(this.$AppDetails.start_date)),
            endDate: this.formatDate(moment(this.$AppDetails.end_date))
          };
        }
      }
    },
    fiscalYear() {
      return [
        moment(this.$AppDetails.start_date),
        moment(this.$AppDetails.end_date)
      ];
    },
    checkConsole(event) {
      if (event.startDate && event.endDate) {
        var startDate = this.formatDate(event.startDate);
        var endDate = this.formatDate(event.endDate);
        this.selected_date =
          this.getDateFormat(startDate) +
          " <strong> to </strong> " +
          this.getDateFormat(endDate);

        $.each(this.ranges, (key, value) => {
          if (
            startDate == this.formatDate(value[0]) &&
            endDate == this.formatDate(value[1])
          ) {
            this.selected_date = "<strong>" + key + "</strong>";
          }
        });
        this.$emit("setDateRange", {
          startDate: this.formatDate(startDate),
          endDate: this.formatDate(endDate)
        });
      } else {
        this.dateRange.startDate = event.startDate;
        this.dateRange.endDate = event.endDate;
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  },
  created() {
    this.locale.format = this.org_details.date_format;
    if (
      typeof this.fromDate != "undefined" &&
      typeof this.toDate != "undefined"
    ) {
      this.dateRange = {
        startDate: this.fromDate,
        endDate: this.toDate
      };
      this.checkConsole(this.dateRange);
    }
  },
  computed: {
    ...mapGetters(["org_details"])
  }
};
</script>

<style>
</style>
